<template>
  <v-card outlined>
    <v-card-title class="text-subtitle-2 grey lighten-4 text-break">
      <v-icon>mdi-magnify</v-icon> General
    </v-card-title>
    <v-card-text>
      <!-- labels -->
      <br v-show="$vuetify.breakpoint.mdAndUp" />
      <!-- show these labels if display > 960px -->
      <v-row v-show="$vuetify.breakpoint.mdAndUp">
        <v-col cols="3" class="text-subtitle-2">
          <label>Name Initial</label>
        </v-col>
        <v-col cols="3" class="text-subtitle-2">
          <label> Candidate Name </label>
        </v-col>
        <v-col cols="3" class="text-subtitle-2">
          <label></label>
        </v-col>
        <v-col cols="3" class="text-subtitle-2">
          <label>Selected Name</label>
        </v-col>
      </v-row>
      <v-divider v-show="$vuetify.breakpoint.mdAndUp"></v-divider>
      <!-- show this if display > 960px -->
      <br v-show="$vuetify.breakpoint.mdAndUp" />
      <!-- show this if display > 960px -->
      <!-- inputs -->
      <v-row>
        <v-col
          cols="12"
          class="text-subtitle-2"
          v-show="$vuetify.breakpoint.smAndDown"
        >
          <!-- show this if display < 960px -->
          <label>Name Initial</label>
        </v-col>

        <v-col cols="12" md="3" class="text-subtitle-2">
          <v-text-field
            dense
            clearable
            v-model="temp['nameInitial']"
            hide-details="auto"
            v-on:input="searchUpdated"
            outlined
          ></v-text-field>
          <br />
          <div v-if="loadingCandidateNames">
            <v-progress-linear rounded indeterminate></v-progress-linear>
          </div>
          <!-- <p>{{ temp["candidateNames"] }}</p>
                      <p>{{ temp["selectedModelNames"] }}</p>
                      <p>{{ temp["selectedPartNames"] }}</p> -->
        </v-col>
        <v-col
          cols="12"
          class="text-subtitle-2"
          v-show="$vuetify.breakpoint.smAndDown"
        >
          <!-- show this if display < 960px -->
          <label> Candidate Name </label>
        </v-col>
        <v-col cols="12" md="3">
          <v-list outlined class="listBox">
            <v-list-item-group
              multiple
              v-model="temp['candidateNames']"
              color="primary"
            >
              <v-list-item
                v-for="item in headerSelects['candidateNames']"
                :key="item.text"
                :value="item.text"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col cols="12" md="3" class="text-subtitle-2" align-self="center">
          <v-row justify="center">
            <v-btn width="100%" v-on:click="addCandidateToSelected()">
              Add ({{ selectedModelsAndPartsCandidateNamesLength }})
            </v-btn>
          </v-row>
          <br />
          <br />
          <v-row justify="center">
            <v-btn width="100%" v-on:click="deleteSelectedFromSelectedNames()">
              Delete ({{ selectedModelsAndPartsSelectedNamesLength }})
            </v-btn>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          class="text-subtitle-2"
          v-show="$vuetify.breakpoint.smAndDown"
        >
          <!-- show this if display < 960px -->
          <label> Selected Name </label>
        </v-col>
        <v-col cols="12" md="3">
          <v-list outlined class="listBox">
            <v-list-item-subtitle
              class="grey lighten-4"
              v-show="
                headerSelects['selectedModelNames'] != undefined &&
                headerSelects['selectedModelNames'].length > 0
              "
            >
              MODELS
            </v-list-item-subtitle>
            <v-list-item-group
              dense
              multiple
              v-model="temp['selectedModelNames']"
              color="primary"
            >
              <v-list-item
                v-for="item in headerSelects['selectedModelNames']"
                :key="item"
                :value="item"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
            <v-list-item-subtitle
              class="grey lighten-4"
              v-show="
                headerSelects['selectedPartNames'] != undefined &&
                headerSelects['selectedPartNames'].length > 0
              "
            >
              PARTS
            </v-list-item-subtitle>
            <v-list-item-group
              dense
              multiple
              v-model="temp['selectedPartNames']"
              color="primary"
            >
              <v-list-item
                v-for="item in headerSelects['selectedPartNames']"
                :key="item"
                :value="item"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
      <br />
      <v-divider></v-divider>
      <!-- buttons -->
      <v-row>
        <v-col cols="6" md="2">
          <v-btn
            width="100%"
            :color="searchingForModels ? 'primary' : ''"
            v-on:click="switchModelsAndParts('Models')"
          >
            Models
          </v-btn>
        </v-col>
        <v-col cols="6" md="2">
          <v-btn
            width="100%"
            :color="!searchingForModels ? 'primary' : ''"
            v-on:click="switchModelsAndParts('Parts')"
          >
            Parts
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    searchPassed: {
      typeof: Array,
      required: true,
    },
    headerSelects: {
      typeof: Array,
      required: true,
    },
  },
  data() {
    return {
      searchingForModels: true,
      loadingCandidateNames: false,
      searchTimeOut: null,
      temp: {
        nameInitial: null,
        candidateNames: [],
        selectedModelNames: [],
        selectedPartNames: [],
      },
    };
  },
  computed: {
    // searchStore() {
    //   return this.$store.state.searchAdvancedStore;
    // },
    // search: {
    //   get() {
    //     return this.searchStore.search;
    //   },
    //   set(value) {
    //     this.$store.commit("updateSearch", value);
    //   },
    // },
    // headerSelects: {
    //   get() {
    //     return this.searchStore.headerSelects;
    //   },
    //   set(value) {
    //     this.$store.commit("updateHeaderSelects", value);
    //   },
    // },
    selectedModelsAndPartsCandidateNamesLength() {
      var selected = 0;
      if (this.temp["candidateNames"] != undefined) {
        selected += this.temp["candidateNames"].length;
      }
      return selected;
    },
    selectedModelsAndPartsSelectedNamesLength() {
      var selected = 0;
      if (this.temp["selectedModelNames"] != undefined) {
        selected += this.temp["selectedModelNames"].length;
      }
      if (this.temp["selectedPartNames"] != undefined) {
        selected += this.temp["selectedPartNames"].length;
      }
      return selected;
    },
  },
  methods: {
    addCandidateToSelected() {
      var array;
      if (this.selectedModelsAndPartsCandidateNamesLength > 0) {
        if (this.searchingForModels) {
          array = this.headerSelects["selectedModelNames"];
          if (this.arrayIsNotUndefinedOrArrayLengthIsNot0(array)) {
            this.temp["candidateNames"].forEach((element) => {
              if (array.indexOf(element) === -1) array.push(element);
            });
          } else {
            this.headerSelects["selectedModelNames"] = [
              ...this.temp["candidateNames"],
            ];
          }
        } else {
          array = this.headerSelects["selectedPartNames"];
          if (this.arrayIsNotUndefinedOrArrayLengthIsNot0(array)) {
            this.temp["candidateNames"].forEach((element) => {
              if (array.indexOf(element) === -1) array.push(element);
            });
          } else {
            this.headerSelects["selectedPartNames"] = [
              ...this.temp["candidateNames"],
            ];
          }
        }
        this.updateParent();
      }
    },
    deleteSelectedFromSelectedNames() {
      if (this.selectedModelsAndPartsSelectedNamesLength > 0) {
        var arrayModel = this.headerSelects["selectedModelNames"];
        var arrayModelSelected = this.temp["selectedModelNames"];
        if (
          this.arrayIsNotUndefinedOrArrayLengthIsNot0(arrayModel) &&
          this.arrayIsNotUndefinedOrArrayLengthIsNot0(arrayModelSelected)
        ) {
          arrayModelSelected.forEach((element) => {
            var indexOfElement = arrayModel.indexOf(element);
            if (indexOfElement != -1) arrayModel.splice(indexOfElement, 1);
          });
        }
        var arrayPart = this.headerSelects["selectedPartNames"];
        var arrayPartSelected = this.temp["selectedPartNames"];
        if (
          this.arrayIsNotUndefinedOrArrayLengthIsNot0(arrayPart) &&
          this.arrayIsNotUndefinedOrArrayLengthIsNot0(arrayPartSelected)
        ) {
          arrayPartSelected.forEach((element) => {
            var indexOfElement = arrayPart.indexOf(element);
            if (indexOfElement != -1) arrayPart.splice(indexOfElement, 1);
          });
        }
        this.updateParent();
      }
    },
    updateParent() {
      this.$forceUpdate();

      //   let dataToSend = [];
      //  dataToSend["selectedModelNames"] = this.headerSelects["selectedModelNames"];
      //   dataToSend["selectedPartNames"] = this.headerSelects["selectedPartNames"];
      //   this.$emit("updateModelsAndParts")
    },
    switchModelsAndParts(buttonName) {
      if (buttonName === "Models") {
        if (!this.searchingForModels) {
          this.searchingForModels = true;
          this.clearModelsAndPartsGeneral();
        }
      } else if (buttonName === "Parts") {
        if (this.searchingForModels) {
          this.searchingForModels = false;
          this.clearModelsAndPartsGeneral();
        }
      }
    },
    clearModelsAndPartsGeneral() {
      this.$set(this.temp, "candidateNames", []);
      this.$set(this.headerSelects, "candidateNames", []);
      this.temp["nameInitial"] = undefined;
    },
    searchUpdated() {
      clearTimeout(this.searchTimeOut);
      this.searchTimeOut = setTimeout(() => {
        // if nameInitial != empty && nameInitial.length > 3
        this.loadingCandidateNames = this.temp["nameInitial"] != null && this.temp["nameInitial"].length > 3;
        if(this.loadingCandidateNames){ 
          if (this.searchingForModels ){ // && this.temp["nameInitial"] != null) {
            this.searchForModelNames();
          } else { // if (this.temp["nameInitial"] != null) {
            this.searchForPartNames();
          }
        }
      }, 1000);
    },
    searchForModelNames() {
      this.$api
        .getModelNames(this.temp["nameInitial"])
        .then((resp) => {
          this.headerSelects["candidateNames"] = resp.data;
          this.$forceUpdate();
        })
        .finally(() => (this.loadingCandidateNames = false));
    },
    searchForPartNames() {
      this.$api
        .getPartNames(this.temp["nameInitial"])
        .then((resp) => {
          this.headerSelects["candidateNames"] = resp.data;
          this.$forceUpdate();
        })
        .finally(() => (this.loadingCandidateNames = false));
    },
    arrayIsNotUndefinedOrArrayLengthIsNot0(array) {
      return array != undefined && array.length != 0;
    },
  },
};
</script>

<style scoped>
.listBox {
  height: 200px;
  overflow-y: auto;
}
</style>